
































































































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import { validHourHHmm } from '@/helpers/validHour';
import { IdNomeDTO } from '@/interfaces/base-dto';
import { AprovacaoAgendadaMultiParmDTO, AprovacaoAgendadaMultiParteParmDTO } from '@/interfaces/prescription';
import { getAprovationScheduleDetails } from '@/services/prescription';
import { getServerISODate } from '@/services/utils';
import moment from 'moment';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiDatePicker
  }
})
export default class PrescriptionApprovalScheduleMultiModal extends BaseComponent {
  @Prop()
  private modalOpen: boolean;

  @Prop()
  private idPrescricao: number;

  @Prop({default: false})
  private alteracao: boolean;

  loading = false;
  hour = null;
  group: IdNomeDTO[] = [];
  details = null;
  ids = [];
  key = 0;
  today = null;

  quantOptions = [];
  quantAvailable = 0;
  editing = false;

  public form: any = {
    valid: false,
    rules: {
      horario: [(v) => (v && validHourHHmm(v)) || 'Horário inválido'],
      dataProd: [
        (v) => {
          return this.validProdDate(v);
        }
      ]
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    this.onIdPrescricaoChange(this.idPrescricao);
    getServerISODate().subscribe((data) => {
      this.today = data;
    });
  }

  @Watch('idPrescricao')
  onIdPrescricaoChange(id) {
    if (!id) {
      return;
    }
    this.loading = true;

    getAprovationScheduleDetails(id).subscribe(
      (res) => {
        this.loading = false;
        this.group = res.grupo;
        this.hour = res.horarioConfig;
        this.details = res;
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }

  public closeForm(): void {
    this.$emit('close');
  }

  public save(): void {
    let parm = new AprovacaoAgendadaMultiParmDTO()
    parm.idPrescricao = this.idPrescricao;
    parm.partes = this.details.partes.filter(p => p.alteravel).map(p => {
      let dto = new AprovacaoAgendadaMultiParteParmDTO()
      dto.data = p.data;
      dto.hora = p.hora;
      dto.quantidade = p.qtde;
      return dto;
    });
    this.$emit('save', parm);
  }

  editItem(item) {
    let options = [];
    for (let i = 1; i <= item.qtde; i++) {
      options.push(i);
    }
    this.quantOptions = options;
    item.editing = true;
    this.key++;
    this.editing = true;
  }

  confirmEditItem(item) {
    if (item.qtde == 0) {
      this.details.partes.splice(
        this.details.partes.findIndex((i) => i == item),
        1
      );
    }
    this.editing = false;
    item.editing = false;
    this.key++;
    this.calcQuantAvailable();
    if (this.quantAvailable > 0) {
      let part = {
        qtde: this.quantAvailable,
        data: null,
        hora: this.details.horarioConfig,
        alteravel: true,
        editing: false
      };
      this.details.partes.push(part);
      this.editItem(part);      
    } else {
      const grouped = this.details.partes.reduce((acc, part) => {
        const key = part.data + part.hora;
        if (!acc[key]) {
          acc[key] = { ...part };
        } else {
          acc[key].qtde += part.qtde;
        }
        return acc;
      }, {});

      this.details.partes = Object.values(grouped);

      this.details.partes.sort((o1, o2) => {
        return o1.data + o1.hora == o2.data + o2.hora ? 0 : o1.data + o1.hora < o2.data + o2.hora ? -1 : 1;
      });
    }
  }

  calcQuantAvailable() {
    let val = this.details.qtdeBolsas;
    this.details.partes.forEach((i) => {
      val -= i.qtde;
    });
    this.quantAvailable = val;
  }

  validProdDate(v) {
    if (!v || v.length < 8) {
      return 'Informe uma data válida';
    }
    let date = moment(v, 'DDMMYYYY');
    let today = moment(this.today, 'YYYY-MM-DD');
    if (date.isBefore(today)) {
      return 'Nao deve ser no passado';
    }
    let max = moment(this.details.dataProducaoPlanejada, 'YYYY-MM-DD');
    if (date.isAfter(max)) {
      return 'Nao deve ser maior que ' + max.format('DD/MM/YYYY');
    }
    return true;
  }
}
